import { z } from "zod";
import { isWeakPassword } from "@utils/passwordValidation";
import type { ChangePasswordMessages } from "../types";

const createNewPasswordSchema = (messages: ChangePasswordMessages) =>
	z
		.string({ required_error: messages.passwordRequired })
		.min(8, messages.minPasssword)
		.max(16, messages.maxPasssword)
		.regex(/[A-Z]/, messages.upperLetter)
		.regex(/[a-z]/, messages.lowerLetter)
		.regex(/[0-9]/, messages.aNumber)
		.regex(/[^a-zA-Z0-9]/, messages.specialCharcter)
		.refine(val => !isWeakPassword(val), messages.weakPassword);

export const createChangePasswordSchema = (messages: ChangePasswordMessages) =>
	z
		.object({
			oldPassword: z
				.string({ required_error: messages.oldPasswordRequired })
				.min(1, messages.oldPasswordRequired),
			newPassword: createNewPasswordSchema(messages),
			confirmPassword: createNewPasswordSchema(messages),
		})
		.refine(data => data.newPassword === data.confirmPassword, {
			message: messages.passwordMismatch,
			path: ["confirmPassword"],
		});
